import axiosInstance from '@/api/axiosInstance';

export const getMyProfile = async () => {
  const response = await axiosInstance.get('/users/me');
  return response.data;
};

export const updateMyProfile = async (profileData) => {
  const response = await axiosInstance.put('/users/me/profile', profileData);
  return response.data;
};

export const getMetadata = async () => {
  const response = await axiosInstance.get('/metadata');
  return response.data;
};

export const sendPhoneVerification = async (phoneData) => {
  const response = await axiosInstance.post('/users/me/phone/verification', phoneData);
  return response.data;
};

export const bindPhoneNumber = async (data) => {
  const response = await axiosInstance.put('/users/me/phone', data);
  return response.data;
};

export const sendEmailVerificationForChangeEmail = async (email) => {
  const response = await axiosInstance.post('/users/me/email/verification', {
    email,
  });
  return response.data;
};
